import { createLlmExecutor } from "./router.js";
import type { LlmExecutorOptions, LlmTaskExecutor } from "./types.js";

export interface LlmComposition {
  createExecutor(configPath?: string, options?: LlmExecutorOptions): LlmTaskExecutor;
}

export const PRODUCTION_LLM_COMPOSITION: LlmComposition = {
  createExecutor: createLlmExecutor,
};
